function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
import PartitionValidationErrors from '@/apps/attributes/modules/use_cases/components/PartitionValidationErrors';
import { extractCreateTables, extractReferencedTables, buildRewrites, buildReferencedTablesPayload, applyRewrites } from '@/apps/attributes/utils/sql_parser';
export default {
  name: 'EditScriptDialog',
  components: {
    DialogsComponent: DialogsComponent,
    PartitionValidationErrors: PartitionValidationErrors
  },
  data: function data() {
    var _this = this;
    return {
      DIALOG_EDIT_SCRIPT: 'DIALOG_EDIT_SCRIPT',
      item: null,
      valid: false,
      isDragging: false,
      sending: false,
      parseErrors: [],
      parsedSqlText: '',
      createRewrites: new Map(),
      referencedRewrites: new Map(),
      referencedTablesRaw: [],
      partitionValidationBlocked: false,
      partitionValidation: null,
      form: {
        script_file: null
      },
      rules: {
        file: [function (v) {
          return !!v || _this.$t('create_attribute.rules.file_required');
        }, function (v) {
          return !v || v.size < 5000000 || _this.$t('create_attribute.rules.file_size');
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('attribute', ['businessUserServiceAccounts'])), mapState('data-platform', ['companyCode'])), {}, {
    isAttributeAdmin: function isAttributeAdmin() {
      var roles = window.userInfo && window.userInfo.userRoles || [];
      return roles.includes('attribute_admin');
    },
    dbReadNames: function dbReadNames() {
      return (this.businessUserServiceAccounts || []).map(function (u) {
        return u.db_read_name;
      }).filter(Boolean);
    },
    currentVersion: function currentVersion() {
      if (!this.item) return '-';
      var oa = this.item.output_attributes || {};
      return oa.script_version || 1;
    },
    currentFilename: function currentFilename() {
      if (!this.item) return '-';
      var oa = this.item.output_attributes || {};
      return oa.script_filename || this.item.procedure_name || '-';
    },
    canSubmit: function canSubmit() {
      var file = this.form.script_file;
      return !!file && file.size < 5000000 && this.parseErrors.length === 0 && !this.partitionValidation && !this.sending;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    open: function open(item) {
      this.item = item;
      this.reset();
      if (!this.businessUserServiceAccounts || this.businessUserServiceAccounts.length === 0) {
        this.$store.dispatch('attribute/getBusinessUserServiceAccounts', this.companyCode);
      }
      this.$refs[this.DIALOG_EDIT_SCRIPT].onOpen();
    },
    close: function close() {
      this.$refs[this.DIALOG_EDIT_SCRIPT].onClose();
    },
    reset: function reset() {
      this.form = {
        script_file: null
      };
      this.parseErrors = [];
      this.parsedSqlText = '';
      this.createRewrites = new Map();
      this.referencedRewrites = new Map();
      this.referencedTablesRaw = [];
      this.partitionValidationBlocked = false;
      this.partitionValidation = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    dropFile: function dropFile(e) {
      this.isDragging = false;
      var files = e.dataTransfer.files;
      if (files.length > 0) {
        var file = files[0];
        if (file.name.toLowerCase().endsWith('.sql')) {
          this.form.script_file = file;
        } else {
          tasks.toast.error(this.$t('create_attribute.errors.invalid_file_type'));
        }
      }
    },
    onFileSelected: function onFileSelected() {
      this.isDragging = false;
      this.parseErrors = [];
      this.parsedSqlText = '';
      this.createRewrites = new Map();
      this.referencedRewrites = new Map();
      this.referencedTablesRaw = [];
      this.partitionValidationBlocked = false;
      this.partitionValidation = null;
    },
    readFileAsText: function readFileAsText(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    parseAndPreview: function () {
      var _parseAndPreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var sqlText, createTables, referencedTables, _buildRewrites, createTableRewrites, referencedRewrites, errors;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.parseErrors = [];
              this.partitionValidation = null;
              this.createRewrites = new Map();
              this.referencedRewrites = new Map();
              this.parsedSqlText = '';
              if (!(!this.businessUserServiceAccounts || this.businessUserServiceAccounts.length === 0)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.$store.dispatch('attribute/getBusinessUserServiceAccounts', this.companyCode);
            case 1:
              _context.n = 2;
              return this.readFileAsText(file);
            case 2:
              sqlText = _context.v;
              this.parsedSqlText = sqlText;
              createTables = extractCreateTables(sqlText);
              referencedTables = extractReferencedTables(sqlText);
              _buildRewrites = buildRewrites(createTables, referencedTables, this.dbReadNames), createTableRewrites = _buildRewrites.createTableRewrites, referencedRewrites = _buildRewrites.referencedRewrites, errors = _buildRewrites.errors;
              this.parseErrors = errors;
              this.createRewrites = createTableRewrites;
              this.referencedRewrites = referencedRewrites;
              this.referencedTablesRaw = referencedTables.map(function (r) {
                return {
                  dataset: r.dataset,
                  table: r.table
                };
              });
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function parseAndPreview(_x) {
        return _parseAndPreview.apply(this, arguments);
      }
      return parseAndPreview;
    }(),
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var withPartitionOverride,
          overrideReason,
          transformedSql,
          referencedTablesRewritten,
          fileBase64,
          payload,
          result,
          newVersion,
          status,
          partitionVal,
          respData,
          msg,
          _args2 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              withPartitionOverride = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              if (this.item) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (this.form.script_file) {
                _context2.n = 2;
                break;
              }
              tasks.toast.error(this.$t('create_attribute.rules.file_required'));
              return _context2.a(2);
            case 2:
              if (!(this.form.script_file.size >= 5000000)) {
                _context2.n = 3;
                break;
              }
              tasks.toast.error(this.$t('create_attribute.rules.file_size'));
              return _context2.a(2);
            case 3:
              this.setShowLoading(true);
              _context2.p = 4;
              _context2.n = 5;
              return this.parseAndPreview(this.form.script_file);
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              console.error(_t);
              tasks.toast.error(this.$t('error_messages.error_general'), this.$t('titles.error'));
              this.setShowLoading(false);
              return _context2.a(2);
            case 7:
              this.setShowLoading(false);
              if (!(this.parseErrors.length > 0)) {
                _context2.n = 8;
                break;
              }
              return _context2.a(2);
            case 8:
              this.sending = true;
              this.setShowLoading(true);
              _context2.p = 9;
              overrideReason = '';
              if (!withPartitionOverride) {
                _context2.n = 10;
                break;
              }
              overrideReason = window.prompt(this.$t('create_attribute.partition_validation.override_reason_prompt')) || '';
              overrideReason = overrideReason.trim();
              if (overrideReason) {
                _context2.n = 10;
                break;
              }
              tasks.toast.error(this.$t('create_attribute.partition_validation.override_reason_required'));
              return _context2.a(2);
            case 10:
              transformedSql = applyRewrites(this.parsedSqlText, this.createRewrites, this.referencedRewrites);
              referencedTablesRewritten = buildReferencedTablesPayload(this.referencedRewrites);
              fileBase64 = btoa(unescape(encodeURIComponent(transformedSql)));
              payload = {
                script_file: fileBase64,
                script_name: this.form.script_file.name,
                operator: window.userInfo.email,
                referenced_tables: referencedTablesRewritten
              };
              if (withPartitionOverride) {
                payload.partition_validation_override = true;
                payload.partition_validation_override_reason = overrideReason;
              }
              _context2.n = 11;
              return UseCasesService.updateAutomationScript(this.item.automate_id, payload);
            case 11:
              result = _context2.v;
              newVersion = result && result.data && result.data.script_version;
              this.partitionValidationBlocked = false;
              tasks.toast.success(this.$t('create_attribute.edit_script.success', {
                version: newVersion || '?'
              }));
              this.$emit('updated', {
                automate_id: this.item.automate_id,
                version: newVersion
              });
              this.close();
              _context2.n = 14;
              break;
            case 12:
              _context2.p = 12;
              _t2 = _context2.v;
              status = _t2 && _t2.response && _t2.response.status;
              partitionVal = _t2 && _t2.response && _t2.response.data && _t2.response.data.data && _t2.response.data.data.partition_validation;
              if (!(status === 422 && partitionVal && partitionVal.ok === false && Array.isArray(partitionVal.errors))) {
                _context2.n = 13;
                break;
              }
              // El panel inline (PartitionValidationErrors) muestra el detalle accionable
              // (tabla, línea, snippet, motivo y SQL sugerido). El toast es solo un aviso breve.
              this.partitionValidationBlocked = true;
              this.partitionValidation = partitionVal;
              tasks.toast.error(this.$t('create_attribute.partition_validation.blocked'));
              return _context2.a(2);
            case 13:
              respData = _t2 && _t2.response && _t2.response.data;
              msg = respData && respData.message || this.$t('error_messages.error_general');
              console.error(_t2);
              tasks.toast.error(msg, this.$t('titles.error'));
            case 14:
              _context2.p = 14;
              this.sending = false;
              this.setShowLoading(false);
              return _context2.f(14);
            case 15:
              return _context2.a(2);
          }
        }, _callee2, this, [[9, 12, 14, 15], [4, 6]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  })
};